import { render } from "./ProdBrandEditorPage.vue?vue&type=template&id=2f1b7a32&ts=true"
import script from "./ProdBrandEditorPage.vue?vue&type=script&lang=ts"
export * from "./ProdBrandEditorPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__